import { EventEmitter } from 'events';

export const AppEventType = {
    RELOAD_USER: 'reloadUser',
    RESET_ACTION_BUTTON: 'resetActionButton',
    CALENDAR_UPDATED: 'calendarUpdated',
    LOGIN_SUCCESS: 'loginSuccess',
    LOGOUT: 'logout',
};

export const appEvents = new EventEmitter();